import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import { AutoLogout } from "./AutoLogout";
import { H2 } from "./styled/H2";
import { isPrintMode } from "./QueryParameter";

export class SideEffectAutoLogout extends Component {
    state = {
        isLoggedOut: false
    };

    setLoggedOut = () => this.setState({ isLoggedOut: true });

    render() {
        if (this.state.isLoggedOut) {
            return (
                <H2
                    data-testid="logout-message"
                    textAlign="center"
                    padding="1em 0 0.25em"
                    margin="0"
                >
                    Sorry, you have been logged out for security.
                    <br />
                    Please refresh the page or select a tab above to resume.
                </H2>
            );
        }

        return (
            <Fragment>
                {this.props.children}
                {this.props.enabled && !isPrintMode() && <AutoLogout logout={this.setLoggedOut} />}
            </Fragment>
        );
    }
}

SideEffectAutoLogout.defaultProps = {
    enabled: true
};

SideEffectAutoLogout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    enabled: PropTypes.bool
};
